import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  TextField
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SnackBarAlert from '../components/HelperComponents/SnackBarAlert';
import DashboardNavbar from '../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../layouts/dashboard/DashboardSidebar';
import { DeviceOrderdButtons } from '../components/_dashboard/soundbox';
import { useAuth } from '../components/customContextProviders/AuthContext';
import Page from '../components/Page';
import { GetUserById, UpdateUserToNox } from '../network/User';
import { parseValidationErrorMessage } from '../utils/Utilities';
import ChangePasswordModal from '../components/_dashboard/soundbox/ChangePasswordModal';

const primaryTypographyStyles = {
  fontSize: { xs: '12px', sm: '14px' },
  fontWeight: 700
};

export default function UserProfile() {
  const { sessionUserData } = useAuth();
  const [listDense, setListDense] = useState(false);
  const [listSecondary, setListSecondary] = useState(false);
  const [userDetail, setUserDetail] = useState([]);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const GetUserDetails = () => {
    setUserDetail((prev) => ({
      ...prev,
      data: [],
      loading: true,
      currentImageId: null
    }));
    GetUserById(sessionUserData?.user?.id)
      .then((res) => {
        setUserDetail((prev) => ({
          ...prev,
          data: res?.data,
          loading: false
        }));
      })
      .catch((err) => {
        setUserDetail((prev) => ({
          ...prev,
          loading: false
        }));
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUserDetail((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: value
      }
    }));
  };
  useEffect(() => {
    GetUserDetails();
  }, []);

  const updateUserDetails = () => {
    setIsLoading(true);
    const user = userDetail?.data;
    const payload = {
      name: user.name || '',
      phone: user.phone || '',
      email: user.email || '',
      username: user.username || ''
    };

    UpdateUserToNox(sessionUserData?.user?.id, payload)
      .then((res) => {
        if (res) {
          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: `${payload?.name} successfully updated !`,
            severity: 'success'
          }));
          setIsSnackBarAlertOpen(true);

          GetUserDetails();
        }
      })
      .catch((error) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: parseValidationErrorMessage(error),
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <Page title="User Prolfe">
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <Container maxWidth="false">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <DeviceOrderdButtons />
          <Button
            sx={{ minHeight: '5vh', ml: 1, minWidth: 120, mb: 1 }}
            variant="contained"
            color="whitebg"
            onClick={() => setOpenChangePasswordModal(true)}
          >
            Change Password
          </Button>
        </Box>

        <Card
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            maxHeight: '80vh',
            overflow: 'hidden',
            minHeight: '80vh'
          }}
        >
          {userDetail?.loading ? (
            <Box
              sx={{
                flex: 1, // <-- fills the card vertically
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <CircularProgress size={30} sx={{ color: 'black' }} />
            </Box>
          ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                overflowY: 'auto'
              }}
            >
              <List dense={listDense} key={userDetail?.id} sx={{ p: 0 }}>
                <ListItem
                  sx={{ px: 2, py: 3, backgroundColor: 'white' }}
                  secondaryAction={
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Name"
                      name="name"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      value={userDetail?.data?.name}
                      onChange={handleChange}
                    />
                  }
                >
                  <ListItemText
                    primary=" Name"
                    listSecondary={listSecondary ? 'Secondary text' : null}
                    primaryTypographyProps={primaryTypographyStyles}
                    secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
                  />
                </ListItem>
                <ListItem
                  sx={{ px: 2, py: 3, backgroundColor: 'rgba(176, 185, 199, .1)' }}
                  secondaryAction={
                    <TextField
                      size="small"
                      variant="outlined"
                      label="User Name"
                      name="username"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      value={userDetail?.data?.username}
                      onChange={handleChange}
                    />
                  }
                >
                  <ListItemText
                    primary="Employee ID"
                    listSecondary={listSecondary ? 'Secondary text' : null}
                    primaryTypographyProps={primaryTypographyStyles}
                    secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
                  />
                </ListItem>
                <ListItem
                  sx={{ px: 2, py: 3, backgroundColor: 'white' }}
                  secondaryAction={
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Phone"
                      name="phone"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      value={userDetail?.data?.phone}
                      onChange={handleChange}
                    />
                  }
                >
                  <ListItemText
                    primary="Mobile"
                    listSecondary={listSecondary ? 'Secondary text' : null}
                    primaryTypographyProps={primaryTypographyStyles}
                    secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
                  />
                </ListItem>
                <ListItem
                  sx={{ px: 2, py: 3, backgroundColor: 'rgba(176, 185, 199, .1)' }}
                  secondaryAction={
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Email"
                      name="email"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      value={userDetail?.data?.email}
                      onChange={handleChange}
                    />
                  }
                >
                  <ListItemText
                    primary="Email"
                    listSecondary={listSecondary ? 'Secondary text' : null}
                    primaryTypographyProps={primaryTypographyStyles}
                    secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
                  />
                </ListItem>

                <ListItem
                  sx={{ px: 2, py: 3, backgroundColor: 'white' }}
                  secondaryAction={
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Role"
                      name="role"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '12px', sm: '14px' }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: { xs: '12px', sm: '14px' }
                        }
                      }}
                      value={userDetail?.data?.role}
                      onChange={handleChange}
                      disabled
                    />
                  }
                >
                  <ListItemText
                    primary="Role"
                    listSecondary={listSecondary ? 'Secondary text' : null}
                    primaryTypographyProps={primaryTypographyStyles}
                    secondaryTypographyProps={{ fontSize: { xs: '12px', sm: '14px' } }}
                  />
                </ListItem>
              </List>
            </Box>
          )}
          <Box sx={{ width: '100%', p: 3, textAlign: 'center' }}>
            <LoadingButton
              variant="contained"
              color="primary"
              sx={{ boxShadow: 'none' }}
              loading={isLoading}
              onClick={updateUserDetails}
            >
              SAVE
            </LoadingButton>
          </Box>
        </Card>
      </Container>
      <SnackBarAlert
        open={isSnackBarAlertOpen}
        title={snackBarMetas?.title}
        message={snackBarMetas?.message}
        severity={snackBarMetas?.severity}
        handleClose={() => setIsSnackBarAlertOpen(false)}
      />
      <ChangePasswordModal
        openAssignedModal={openChangePasswordModal}
        handleClose={() => setOpenChangePasswordModal(false)}
      />
    </Page>
  );
}
